import { useState } from "react";
import { AssessmentType } from "types/graphql-schema";

import ManagerEffectivenessReport from "@apps/reporting/components/manager-effectiveness-report";
import PerformanceAssessmentReport from "@apps/reporting/components/performance-assessment-report";
import ReportTypeToggle from "@apps/reporting/components/report-type-toggle";

// The consolidated "Results" report for a review program. When the program has
// both downward (performance) and upward (manager) reviews, a toggle to the
// left of the View input switches between them.
const AssessmentReportTab = ({
  complianceProgramId,
  hasDownward,
  hasUpward,
}: {
  complianceProgramId: number;
  hasDownward: boolean;
  hasUpward: boolean;
}) => {
  const [reportType, setReportType] = useState<AssessmentType>(
    hasDownward ? AssessmentType.Performance : AssessmentType.Manager,
  );
  const showToggle = hasDownward && hasUpward;

  const headerContent = (settings: JSX.Element) => (
    <div className="flex items-center gap-4">
      {showToggle && (
        <ReportTypeToggle activeType={reportType} onChange={setReportType} />
      )}
      {settings}
    </div>
  );

  return reportType === AssessmentType.Performance ? (
    <PerformanceAssessmentReport
      complianceProgramId={complianceProgramId}
      headerContent={headerContent}
      isInReporting={false}
    />
  ) : (
    <ManagerEffectivenessReport
      complianceProgramId={complianceProgramId}
      headerContent={headerContent}
      isInReporting={false}
    />
  );
};

export default AssessmentReportTab;
